/* This file handles the Redux store and *most* State for the React components. 
   Specifically, it implements reducers for any interface action done in Cend.
   It is pretty good about hewing closely to React-Redux convention.
*/
import { createStore, applyMiddleware, combineReducers } from 'redux'
import promiseMiddleware from 'redux-promise-middleware'
import logger from 'redux-logger'
import CFG from './Configconstants'
import CAC from './Constants'

/* The (fail-safe) default state for our store. */
const initialState = {
    sends: [],
    sendlist: [],
    userlist: [],
    watchlist: [],
    username: '',
    currentsenduser: '',
    tickle: 0,
    messageStatus: 'Initializing ...',
    cendVersion: '0.1',
    apiVersion: CFG.APIVERSION,
    clientBase: CFG.BASEURL,
    stringCategory: 'system',
    stringVerb: 'version',
    stringRequestType: 'GET',
    token: CFG.TOKEN,
    postData: '',
}

/* Start of Individual Reducers */

const sends = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case CAC.SENDGET:
            return state;
        case `${CAC.SENDGET}_PENDING`:    
            return state;
        case `${CAC.SENDGET}_FAILURE`:
            return state;
        case `${CAC.SENDGET}_FULFILLED_FAIL`:
            return state;
        case `${CAC.SENDGET}_SUCCESS`:
            if(action.payload === null){
                const empty = [];
                return empty;
            }
            if(action.payload.send === ""){
                const empty = [];
                return empty;
            }
            const newSends = action.payload.send.map(c => {
                return {
                 fromUser: c.fromuser,
                 toUser: c.touser,
                 requestingUser: c.requestinguser,
                 message: c.message,
                 sent: c.sent,
                 seen: c.seen,
                 key: c.sent
                };
        });
            return newSends;
        case `${CAC.SENDGET}_FULFILLED`:
            return state;
    }
    /* Switch would go here. */
    return state;
}

const sendlist = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case CAC.SENDLISTGET:
            return state;
        case `${CAC.SENDLISTGET}_PENDING`:    
            return state;
        case `${CAC.SENDLISTGET}_FAILURE`:
            return state;
        case `${CAC.SENDLISTGET}_FULFILLED_FAIL`:
            return state;
        case `${CAC.SENDLISTGET}_SUCCESS`:
            return action.payload.sendlist;
        case `${CAC.SENDLISTGET}_FULFILLED`:
            return state;
    }
    return state;
}

const userlist = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case CAC.USERLOCALGET:
            return state;
        case `${CAC.USERLOCALGET}_PENDING`:    
            return state;
        case `${CAC.USERLOCALGET}_FAILURE`:
            return state;
        case `${CAC.USERLOCALGET}_FULFILLED_FAIL`:
            return state;
        case `${CAC.USERLOCALGET}_SUCCESS`:
            return action.payload.userslocal;
        case `${CAC.USERLOCALGET}_FULFILLED`:
            return state;
    }
    return state;
}

const currentsenduser = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case `${CAC.CURRENTSENDUSER}`:
            return action.payload;
    }
    return state;
}

const tickle = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case `${CAC.TICKLE}`:
            return state + 1;
    }
    return state;
}

const watchlist = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}


const username = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}


const messageStatus = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}


const cendVersion = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}

const apiVersion = (state, action) => {
    let error; /* Defining variable before it is used / instantiated / whatever. */
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case CAC.VERSIONGET:
            return state;
        case `${CAC.VERSIONGET}_PENDING`:    
            return state;
        case `${CAC.VERSIONGET}_FAILURE`:
            return state;
        case `${CAC.VERSIONGET}_FULFILLED_FAIL`:
            return state;
        case `${CAC.VERSIONGET}_SUCCESS`:
            return action.payload.version;
        case `${CAC.VERSIONGET}_FULFILLED`:
            return state;
    }
    return state;
}

const clientBase = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}

const stringCategory = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}

const stringVerb = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}

const stringRequestType = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}

const token = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    /* Switch would go here. */
    return state;
}

const postData = (state, action) => {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case CAC.POSTUPDATE:
            return action.payload;
        case CAC.SENDPOST:    
            return state;
        case `${CAC.SENDPOST}_PENDING`:    
            return state;
        case `${CAC.SENDPOST}_FAILURE`:
            return state;
        case `${CAC.SENDPOST}_FULFILLED_FAIL`:
            return state;
        case `${CAC.SENDPOST}_SUCCESS`:
            return '';
        case `${CAC.SENDPOST}_FULFILLED`:
            return state;
    }
    return state;
}

/* End of Individual Reducers */

/* Root Reducer followed by Middleware and store convention boilerplate. */

const rootReducer = combineReducers({
    sends,
    sendlist,
    userlist,
    currentsenduser,
    tickle,
    watchlist,
    username,
    messageStatus,
    cendVersion,
    apiVersion,
    clientBase,
    stringCategory,
    stringVerb,
    stringRequestType,
    token,
    postData,
});


const middlewareconst = applyMiddleware(promiseMiddleware(), logger);

const store = createStore(rootReducer, initialState, middlewareconst);

 export default store


// WEBPACK FOOTER //
// ./src/Backend.js